// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from 'react';

const SvgViewList16 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 16 16"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M3 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm1 .04c0-.48.389-.869.868-.869h9.264a.868.868 0 0 1 0 1.737H4.868A.868.868 0 0 1 4 4.039ZM2 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm2.868-1.829a.868.868 0 0 0 0 1.737h9.264a.868.868 0 0 0 0-1.737H4.868ZM2 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm2.868-1.829a.868.868 0 1 0 0 1.737h9.264a.868.868 0 0 0 0-1.737H4.868Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgViewList16;
